import Navbar  from "../../../NavBar/NavBar.js";
import Footer from "../../../Home/Footer.js"
import Whatsapp from "../../../Home/Whatsapp.js";
import Spinner from "../../../Home/Spinner.js";
import SectionUs2 from "./page_us/Solution-US-2/SectionUs2.js";
import { useEffect } from "react";



const PlafondsMursTendus = () =>{


  useEffect(() => {
  // ========= HELPERS =========
  const setMeta = (name, content) => {
    let tag = document.querySelector(`meta[name='${name}']`);
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("name", name);
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", content);
  };

  const setMetaProperty = (property, content) => {
    let tag = document.querySelector(`meta[property='${property}']`);
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("property", property);
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", content);
  };

  // ========= TITLE =========
  document.title =
    "Habillage Mural Maroc | Revêtement & Design Haut de Gamme – UNIK SYSTEM";

  // ========= BASIC SEO =========
  setMeta(
    "description",
    "Habillage mural au Maroc avec UNIK SYSTEM : panneaux décoratifs, revêtements muraux design et finitions haut de gamme pour villas, hôtels et espaces professionnels."
  );

  setMeta(
    "keywords",
    "habillage mural maroc, revetement mural maroc, panneau mural design maroc, mur decoratif maroc, decoration murale luxe maroc, panneau mural moderne maroc, UNIK SYSTEM walldress"
  );

  setMeta("robots", "index, follow");
  setMeta("author", "UNIK SYSTEM");

  // ========= CANONICAL =========
  let canonical = document.querySelector("link[rel='canonical']");
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }
  canonical.setAttribute("href", "https://unik-system.com/walldress-habillage-mural-maroc");

  // ========= OPEN GRAPH =========
  setMetaProperty(
    "og:title",
    "Habillage Mural Maroc – Design & Luxe | UNIK SYSTEM"
  );
  setMetaProperty(
    "og:description",
    "Revêtements muraux design et panneaux décoratifs pour un intérieur élégant et moderne."
  );
  setMetaProperty(
    "og:image",
    "https://unik-system.com/static/media/1.67dbe73ae14da710f4e8.webp"
  );
  setMetaProperty(
    "og:url",
    "https://unik-system.com/walldress-habillage-mural-maroc"
  );
  setMetaProperty("og:type", "website");
  setMetaProperty("og:locale", "fr_FR");

  // ========= TWITTER =========
  setMeta("twitter:card", "summary_large_image");
  setMeta(
    "twitter:title",
    "Habillage Mural Maroc – UNIK SYSTEM"
  );
  setMeta(
    "twitter:description",
    "Panneaux décoratifs et revêtement mural design haut de gamme."
  );
  setMeta(
    "twitter:image",
    "https://unik-system.com/static/media/1.67dbe73ae14da710f4e8.webp"
  );

  // ========= SCHEMA (DESIGN SERVICE) =========
  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "UNIK SYSTEM",
    url: "https://unik-system.com",
    description:
      "Spécialiste en habillage mural design et décoration intérieure au Maroc.",
    address: {
      "@type": "PostalAddress",
      addressCountry: "MA",
    },
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "Habillage Mural",
      itemListElement: [
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Panneaux Muraux Décoratifs"
          }
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Revêtement Mural Design"
          }
        }
      ]
    }
  };

  let script = document.querySelector("#schema-us-walldress");
  if (!script) {
    script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "schema-us-walldress";
    document.head.appendChild(script);
  }
  script.innerHTML = JSON.stringify(schema);

  // ========= FAQ SCHEMA =========
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "C’est quoi l’habillage mural ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "C’est une solution décorative qui permet de transformer un mur avec des panneaux ou revêtements design."
        }
      },
      {
        "@type": "Question",
        name: "Pour quels espaces ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Villas, hôtels, bureaux et espaces commerciaux."
        }
      },
      {
        "@type": "Question",
        name: "Pourquoi choisir UNIK SYSTEM ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Design sur mesure, qualité premium et finitions haut de gamme adaptées à chaque projet."
        }
      }
    ]
  };

  let faqScript = document.querySelector("#faq-schema-us-walldress");
  if (!faqScript) {
    faqScript = document.createElement("script");
    faqScript.type = "application/ld+json";
    faqScript.id = "faq-schema-us-walldress";
    document.head.appendChild(faqScript);
  }
  faqScript.innerHTML = JSON.stringify(faqSchema);

}, []);




  
    return(
        <div className="body">
            <Spinner/>
            <Navbar/>
            <Whatsapp/>
            <SectionUs2/>
            <Footer/>
        </div>    
    )
};

export default PlafondsMursTendus;